//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "./template/siteMapUploadItemTemplate.html",
  "./template/siteMapUploadsTemplate.html",
], function (Marionette, SiteMapUploadItemTemplate, SiteMapUploadsTemplate) {
  "use strict";

  var SiteMapUploadsView = {};

  SiteMapUploadsView.siteMapUploadItemView = Marionette.ItemView.extend({
    template: SiteMapUploadItemTemplate,
    tagName: "<tr>",
    textboxes: {
      "#siteMapUploadDescription": {
        enableSelector: ["#siteMapUploadDescription"],
        modelAttribute: "description",
        placeholder: "admin.siteMaps.uploads.description",
      },
    },
    triggers: {
      "click .site-map-upload-delete": "delete:upload",
    },
  });

  SiteMapUploadsView.siteMapUploadsView = Marionette.CompositeView.extend({
    template: SiteMapUploadsTemplate,
    itemView: SiteMapUploadsView.siteMapUploadItemView,
    itemViewContainer: "tbody",
    events: {
      "change #addUpload": function (e) {
        var file = e.target.files[0];
        this.trigger("add:upload", file, e.target.form);
      },
    },
  });

  return SiteMapUploadsView;
});
